import { LEGACY_STEP_TO_FLOW_FUNCTION } from '../../../API/step-names';
import { LinkedinContact, Message, MessageDirections } from './campaign-statistics-types';

export interface DayMessage {
  contact: LinkedinContact;
  message: Message;
}

/** Schrittname wie im Diagramm (`send_connection_request` → `sendConnectionRequest`). */
export const chartStepName = (functionName: string | undefined): string =>
  (functionName && LEGACY_STEP_TO_FLOW_FUNCTION[functionName]) || functionName || '';

/** Tag wie im Diagramm: UTC-Datum (`YYYY-MM-DD`), so zählt `/analytics/messages/statistics`. */
export const chartDateKey = (date: number): string => new Date(date).toISOString().split('T')[0];

/**
 * Die gesendeten Nachrichten hinter einem Balken: derselbe Tag und derselbe Schritt, aus dem schon geladenen
 * Nachrichtenverlauf — so stimmt das Fenster mit dem Verlauf darunter überein. Älteste zuerst.
 */
export function messagesForDay(
  history: LinkedinContact[],
  dateKey: string,
  stepName: string
): DayMessage[] {
  const out: DayMessage[] = [];
  for (const contact of history) {
    for (const message of contact.messages ?? []) {
      if (message.direction !== MessageDirections.SENT || !message.date) continue;
      if (chartDateKey(message.date) !== dateKey) continue;
      if (chartStepName(message.step?.functionName) !== stepName) continue;
      out.push({ contact, message });
    }
  }
  return out.sort((a, b) => a.message.date - b.message.date);
}
